import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NewArrivalsRoutingModule } from './new-arrivals-routing.module';

import {PanelModule} from 'primeng/panel';

import { PlugAndChargeComponent } from './components/plug-and-charge/plug-and-charge.component';
import { SmartChargingComponent } from './components/smart-charging/smart-charging.component';

import { NbImplementationModule } from '../nb-implementation.module';

@NgModule({
  declarations: [
    PlugAndChargeComponent,
    SmartChargingComponent
  ],
  imports: [
    CommonModule,
    NewArrivalsRoutingModule,
    SharedModule,
    TranslateModule,

    PanelModule,
    NbImplementationModule
  ],
})
export class NewArrivalsModule { }
